import { InsertTypes } from "types/graphql"
import useAppContext from "utilities/hooks/useAppContext"

const SYSTEM_EVENT_WITH_TRANSLATION = [
    'change-room',
    'check-in',
    'check-out'
]

type EventNameViewProps = {
    item: {
        name: string,
        insertType: InsertTypes
    }
}

const EventNameView = (props: EventNameViewProps) => {
    const context = useAppContext();

    return <>
        {props.item.insertType == InsertTypes.System && SYSTEM_EVENT_WITH_TRANSLATION.indexOf(props.item.name) > -1 ? context.t(`accommodation.event.system.${props.item.name}`) : props.item.name}
    </>
}


export default EventNameView;
